import { render, staticRenderFns } from "./a2aTransfers.vue?vue&type=template&id=44e3cd40&"
import script from "./a2aTransfers.vue?vue&type=script&lang=js&"
export * from "./a2aTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports